(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.headsup = factory());
}(this, (function () { 'use strict';

  var headsup = (function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$selector = _ref.selector,
        selector = _ref$selector === undefined ? 'header' : _ref$selector,
        _ref$duration = _ref.duration,
        duration = _ref$duration === undefined ? 0.3 : _ref$duration,
        _ref$easing = _ref.easing,
        easing = _ref$easing === undefined ? 'ease' : _ref$easing,
        _ref$delay = _ref.delay,
        delay = _ref$delay === undefined ? 0 : _ref$delay,
        _ref$debounce = _ref.debounce,
        debounce = _ref$debounce === undefined ? false : _ref$debounce;

    var show = true; // initial boolean value
    var prev = window.pageYOffset; // initial window position

    var header = document.querySelector(selector);
    var styles = getComputedStyle(header);

    var headerHeight = function headerHeight() {
      // computes total height of the element
      var widthAndPadding = header.getBoundingClientRect().height;
      var marginTop = parseFloat(styles['margin-top']);
      var marginBot = parseFloat(styles['margin-bottom']);

      return widthAndPadding + marginTop + marginBot;
    };

    var fixedShow = function fixedShow() {
      // shows the element
      header.style.top = '0';

      show = true;
    };

    var fixedHide = function fixedHide() {
      // hides the element
      header.style.top = '-' + headerHeight() + 'px';

      show = false;
    };

    var onScrollFunction = function onScrollFunction(_) {
      // performs logic on each scroll event
      var current = window.pageYOffset;

      current > prev && current >= headerHeight() / 2 ? show ? fixedHide() : null : show ? null : fixedShow();

      prev = current;
    };

    var debounceFunc = function debounceFunc(wait) {
      // debouncing function
      if (!wait) return onScrollFunction;

      var timeout = null;
      return function () {
        if (!timeout) {
          timeout = setTimeout(function () {
            onScrollFunction();
            timeout = null;
          }, wait);
        }
      };
    };

    document // adjust body margin to make space for header
    .body.style['margin-top'] = headerHeight() + 'px';

    Object.assign(header.style, { // assign fixed position and transition to header
      position: 'fixed',
      top: '0',
      transition: 'top ' + duration + 's ' + easing + ' ' + delay + 's'
    });

    window.addEventListener('scroll', debounceFunc(debounce));
  });

  return headsup;

})));
